<template>
  <transition name="modal">
    <div class="modal__backdrop" v-show="show" @click.prevent="conditionalClose">
      <div class="modal__wrapper">
        <section class="modal__container" role="dialog" :aria-hidden="!show" @click.stop>
          <div role="document">
            <slot></slot>
          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    
    data() {
      return {
        focusedElBeforeOpen: '',
        focusableEls: '',
        firstFocusableEl: '',
        lastFocusableEl: ''
      }
    },
    
    props: {
      show: {
        type: Boolean,
        default: false
      },
      restrictClose: {
        // disables closing by clicking the backdrop or hitting the escape key
        // (e.g. for a terms of use modal that requires agreement to view content)
        type: Boolean,
        default: false
      }
    },
    
    methods: {
      close() {
        this.$emit('close')
      },
      conditionalClose() {
        if ( this.$props.restrictClose === false ) this.close()
      },
      
      freezeBody(e) {
        if ( !this.$el.contains(e.target) ) e.preventDefault()
      },
      disableBodyScroll() {
        document.body.setAttribute('style', 'overflow:hidden')
        document.addEventListener('touchmove', this.freezeBody, { passive: false })
      },
      enableBodyScroll() {
        document.body.setAttribute('style', '')
        document.removeEventListener('touchmove', this.freezeBody, { passive: false })
      },
      
      getFocusableEls() {
        const focusables = this.$el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]')
        return Array.prototype.slice.call(focusables)
      },
      
      trapTabs(e) {
        // one of the very few cases where this is a useful thing
        const handleBackwardTab = () => {
          if ( document.activeElement === this.firstFocusableEl ) {
            e.preventDefault()
            this.lastFocusableEl.focus()
          }
        }
        const handleForwardTab = () => {
          if ( document.activeElement === this.lastFocusableEl ) {
            e.preventDefault()
            this.firstFocusableEl.focus()
          }
        }
        if (e.keyCode === 9) {
          if ( this.focusableEls.length === 1 ) {
            e.preventDefault()
            return
          }
          e.shiftKey ? handleBackwardTab() : handleForwardTab()
        }
      }
    },
    
    watch: {
      show(isShowing) {
        if (isShowing) {
          this.disableBodyScroll()
          this.focusedElBeforeOpen = document.activeElement
          
          this.$nextTick(() => {
            this.firstFocusableEl.focus()
            this.$el.addEventListener('keydown', this.trapTabs)
          })
        }
        else {
          this.close()
          this.enableBodyScroll()

          if (this.focusedElBeforeOpen && this.focusedElBeforeOpen.focus) {
            this.focusedElBeforeOpen.focus()
          }

          this.$el.removeEventListener('keydown', this.trapTabs)
        }
      }
    },
    
    mounted() {
      this.focusableEls = this.getFocusableEls()
      this.firstFocusableEl = this.focusableEls[0]
      this.lastFocusableEl = this.focusableEls[ this.focusableEls.length - 1 ]
      
      if (this.show) {
        this.disableBodyScroll()
        this.firstFocusableEl.focus()
        this.$el.addEventListener('keydown', this.trapTabs)
      }
      
      document.addEventListener('keydown', (e) => {
        if ( this.show && e.keyCode === 27 ) this.conditionalClose()
      })
      
      
    }
    
  }
</script>



// WEBPACK FOOTER //
// js/Modal.vue